import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getEventPosition} from "../../../../misc/helpers";

class BodySwipable extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    scrollableSelector: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
  }

  static defaultProps = {
    className: "",
  };

  constructor(props) {
    super(props);
    // this.swipableElement = null;
    this.scrollableElement = null;
    this._isMounted = false;
    this.currentScrollLeft = 0;
    this.x = 0;
    this.y = 0;
    this.delta = 0;
    this.swipeActive = false;
    this.detectedSwipeLeft = false;
    this.detectedSwipeRight = false;
    this.state = {
      swipeActive: false
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.scrollableElement = this.getScrolllableElement();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  getScrolllableElement = () => {
    return this.props.scrollableRef && this.props.scrollableRef.current
      ? this.props.scrollableRef.current
      : document.querySelector(this.props.scrollableSelector);
  }

  handleOnMouseDown = (event) => {
    const {x, y} = getEventPosition(event);
    setTimeout(() => {
      if (!this._isMounted) {
        return false
      }
      this.x = x;
      this.y = y;
      this.swipeActive = true;
      this.detectedSwipeLeft = false;
      this.detectedSwipeRight = false;
      this.setState({
        swipeActive: true
      });
      if (!this.scrollableElement) {
        this.scrollableElement = this.getScrolllableElement();
      }
      this.currentScrollLeft = this.scrollableElement.scrollLeft;
    }, 0);
  };

  handleOnMouseMove = (event) => {
    if (this.swipeActive) {
      const {x, y} = getEventPosition(event);
      const tX = parseFloat((x - this.x).toFixed(2));
      const tY = parseFloat((y - this.y).toFixed(2));
      // console.log('tX', tX);

      if (!this.detectedSwipeRight || !this.detectedSwipeLeft) {
        if (Math.abs(parseFloat(tX)) >= this.delta) {
          if (parseFloat(tX) > this.delta) {
            this.detectedSwipeRight = true;
          } else if (parseFloat(tX) < -this.delta) {
            this.detectedSwipeLeft = true;
          }
        }
      }

      if ((this.detectedSwipeLeft || this.detectedSwipeRight) && Math.abs(tX) > Math.abs(tY)) {
        // console.log("this.detectedSwipeLeft", this.detectedSwipeLeft);
        // console.log("this.detectedSwipeRight", this.detectedSwipeRight);
        // console.log('Math.abs(tX)', Math.abs(tX));
        const scrollLeft = this.detectedSwipeLeft
          ? this.currentScrollLeft + Math.abs(tX)
          : this.currentScrollLeft - Math.abs(tX);
        // this.$scrollableElement.animate({scrollLeft}, 500);
        this.scrollableElement.scrollLeft = scrollLeft;
      }
    }
  };

  handleOnMouseUp = () => {
    setTimeout(() => {
      if (!this._isMounted) {
        return false
      }
      this.x = 0;
      this.y = 0;
      this.swipeActive = false;
      this.detectedSwipeLeft = false;
      this.detectedSwipeRight = false;
      this.setState({
        swipeActive: false
      })
    }, 0)
  };

  render() {
    // const disallowSwipe = this.$scrollableElement && this.$scrollableElement[0] &&
    //   (this.$scrollableElement[0].scrollWidth < this.$scrollableElement[0].clientWidth);
    if (this.props.isMobile) {
      return <div className={this.props.className}>{this.props.children}</div>
    }
    return (
      <div
        // ref={(node) => this.swipableElement = node}
        className={this.props.className + " swipable" + (this.state.swipeActive ? " swipable--active" : "")}
        onMouseDown={this.handleOnMouseDown}
        onMouseMove={this.handleOnMouseMove}
        onMouseLeave={this.handleOnMouseUp}
        onMouseUp={this.handleOnMouseUp}>
        {this.props.children}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    navigationLoadingActive: store.navigationState.navigationLoadingActive,
    isMobile: store.serverState.isMobile,
  }
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BodySwipable);
